import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword as forgotPasswordApi } from "../../api/authApi";
import Loader from "../common/Loader";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    const result = await forgotPasswordApi(email);

    if (result.success) {
      setMessage(result.message);
      setEmail("");
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

  return (
    <div className="container d-flex align-items-center justify-content-center min-vh-100">
      <div
        className="card card-shadow p-4 p-md-5"
        style={{ maxWidth: "420px", width: "100%" }}
      >
        <div className="text-center mb-4">
          <img
            src="/logo/Paynuts-logo-2026.png"
            alt="PayNuts"
            className="me-2"
            style={{ height: "40px" }}
          />
          <h4 className="ms-mb-2 text-blaze-orange">Forgot Password</h4>
          <p className="text-theme-muted small">
            Enter your email and we'll send you a password reset link
          </p>
        </div>

        {loading ? (
          <Loader message="Sending reset link..." size="medium" />
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                autoFocus
              />
            </div>

            {message && <div className="alert alert-success py-2">{message}</div>}
            {error && <div className="alert alert-danger py-2">{error}</div>}

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </button>
          </form>
        )}

        <div className="mt-3 text-center">
          <Link to="/login" className="text-decoration-none">
            <i className="bi bi-arrow-left me-1"></i>Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;